module.exports = __webpack_public_path__ + "img/Animacion-caja2.9829acd3.gif";